import { toast } from 'components/RevxMessage';
import { FlushHighResFileREsponseDTO } from 'domains/jobconfigDomain';
import jobService from 'services/jobService';

// Gateway codes returned by the flush-high-res endpoints meaning the Canva
// refresh token is missing / expired, so the user must (re)authorize.
const CANVA_NO_REFRESH_TOKEN_CODES = [66104, 66107];

const IN_PROGRESS_MESSAGE =
  'High-resolution file refresh is already in progress. Please check back later.';
const FAILED_MESSAGE =
  'Failed to refresh the high-resolution file. Please try again later.';

// Opens the Canva authorization page in a popup window. Returns whether a
// window was actually opened.
async function startCanvaAuthorization(): Promise<boolean> {
  try {
    const result = await jobService.canvaConnectStart();
    const authorizeUrl = result?.authorizeUrl;
    if (authorizeUrl) {
      window.open(authorizeUrl, 'canvaConnect', 'popup,width=600,height=760');
      return true;
    }
  } catch {
    // fall through to the failure toast
  }
  return false;
}

/**
 * Runs a flush-high-res request and reacts to the response:
 * - success            -> "already in progress" toast
 * - missing refreshToken (code 66104 / 66107) -> start Canva OAuth authorization
 * - anything else      -> failure toast
 */
export async function flushHighResAndHandle(
  flushFn: () => Promise<FlushHighResFileREsponseDTO>
): Promise<void> {
  try {
    const res = await flushFn();

    if (res?.success) {
      toast(IN_PROGRESS_MESSAGE);
      return;
    }

    if (
      res?.code !== undefined &&
      CANVA_NO_REFRESH_TOKEN_CODES.includes(res.code)
    ) {
      const opened = await startCanvaAuthorization();
      if (opened) {
        return;
      }
    }

    toast.error(FAILED_MESSAGE);
  } catch {
    toast.error(FAILED_MESSAGE);
  }
}
